<template>
  <div class="no-data">
    <div>
      <img src="../assets/no-data.png" width="150" alt="暂无数据">
      <p class="light-gray">暂无数据</p>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .no-data{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    text-align: center;
    margin-top: 30px;
    p{
      width: 100%;
      margin-top: 15px;
    }
  }
</style>
<script>
export default {
  props: {
  },
  data() {
    return {
    }
  },
  watch:{
  },
  methods: {

  },
  created() {
  }
};
</script>